import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLink,
  moreText = '查看更多',
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        {icon ? (
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500/15 text-primary-500">
            <i className={`${icon} text-lg`}></i>
          </span>
        ) : null}
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle ? <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p> : null}
        </div>
      </div>
      {moreLink ? (
        <Link
          to={moreLink}
          className="group flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-500"
        >
          {moreText}
          <i className="ri-arrow-right-s-line text-lg transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      ) : null}
    </div>
  );
}